import { render, staticRenderFns } from "./ProvisionDetail.vue?vue&type=template&id=3f73e651&scoped=true&"
import script from "./ProvisionDetail.vue?vue&type=script&lang=js&"
export * from "./ProvisionDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProvisionDetail.vue?vue&type=style&index=0&id=3f73e651&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f73e651",
  null
  
)

export default component.exports